import { css } from "@emotion/react";

import * as colors from "@styles/emotion-styles/colors";

export const tileWrapper = css`
  display: flex;
  justify-content: center;
`;

export const tile = css`
  padding: 2.5rem 0;
`;

export const body = css`
  text-align: center;
`;

export const footnote = css`
  text-align: center;
  color: ${colors.blue.darkFamily.normal};
`;
